import { useEffect, useState } from "react";
import NavDropdown from "react-bootstrap/NavDropdown";
import { useUserContext } from "../../contexts";
import { axiosAuth } from "../../api/axiosConfig";

import { useNavigate, Link } from "react-router-dom";

import "../../styles/Navbar.css";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowRightFromBracket } from "@fortawesome/free-solid-svg-icons";

const DropdownMenu = () => {
  const { logout, user, settings, updateSettings } = useUserContext();
  const navigate = useNavigate();

  const locations = user?.locID;
  const [selectedLocation, setSelectedLocation] = useState();

  useEffect(() => {
    if (locations && locations.length > 0 && settings.currentLoc) {
      if (!selectedLocation) {
        let currentLoc = locations.filter(
          (loc) => loc.locationId === settings.currentLoc
        )[0];
        setSelectedLocation(
          currentLoc ? currentLoc.name : "Location not found"
        );
      }
    }
  }, [locations, settings, selectedLocation]);

  const handleLogout = async () => {
    try {
      await logout();
    } catch (error) {
      // logout() already clears local session state even when its network
      // call fails, so this is just for visibility — it must not block the
      // redirect below (see AutoLogout.js for the same fix).
      console.error("Logout call failed (session cleared locally regardless):", error);
    } finally {
      navigate("/login");
    }
  };

  async function handleLocationChange(id) {
    try {
      await axiosAuth.patch("/user/update-current-location", {
        userId: settings.userId,
        locationId: id,
      });
      await updateSettings(); // Refresh settings in context
    } catch (error) {
      console.error("Error updating current location:", error);
    }
  }

  const onLocationSelect = (loc) => {
    setSelectedLocation(loc.name);
    handleLocationChange(loc.locationId);
  };

  return (
    <NavDropdown
      className='m-auto d-flex flex-column text-center'
      title={
        <span>
          {/* <i className='bi bi-person-circle me-2'></i> */}
          My Account
        </span>
      }
      id='dropdownMenuLoc'
    >
      <NavDropdown.Item
        as={Link}
        to={`/profile/${user?.id}`}
        className='text-nowrap'
      >
        <i className='bi bi-person-circle me-2'></i>Profile
      </NavDropdown.Item>
      {locations && locations.length > 1 && (
        <>
          <NavDropdown.Header>
            {locations.length > 1 ? "Change location:" : "Location:"}
          </NavDropdown.Header>

          {locations.map((loc) => (
            <NavDropdown.Item
              key={loc.locationId}
              className='text-nowrap'
              active={loc.name === selectedLocation}
              onClick={(e) => {
                e.preventDefault();
                onLocationSelect(loc);
              }}
            >
              {loc.name}
            </NavDropdown.Item>
          ))}
          <NavDropdown.Divider />
        </>
      )}
      <NavDropdown.Item
        className='logout mx-auto'
        type='button'
        onClick={handleLogout}
      >
        Logout
        <FontAwesomeIcon
          className='dropdown-icon'
          id='logout-icon'
          icon={faArrowRightFromBracket}
        />
      </NavDropdown.Item>
    </NavDropdown>
  );
};

export default DropdownMenu;
